import Vue from 'vue'
import Router from 'vue-router'
// import Dashboard from './views/Dashboard.vue'
import DeviceList from './views/device/DeviceList.vue'
import Category from './views/device/Category.vue'
import UserAccount from './views/account/UserAccount.vue'
import DevicesTemplate from './views/DevicesTemplate.vue'
import SensorList from './views/device/SensorList.vue'
// import DataMonitoring from './views/DataMonitoring.vue'
import Alerts from './views/Alerts.vue'
import AlertRule from './views/AlertRule.vue'
import SystemClassification from './views/SystemClassification.vue'
import Subscribe from './views/Subscribe.vue'
import Settings from './views/Settings.vue'
import Login from '@/components/Login'
import Certify from "@/views/Certify.vue";
import OfficeList from "@/views/officeList.vue";
import Role from "@/views/account/Role.vue";
import Resource from "@/views/account/Resource.vue";
import Dashboard from "@/views/Dashboard.vue";
import TemplateCertify from "@/views/certify/TemplateCertify.vue";
import SpecifiedCertify from "@/views/certify/SpecifiedCertify.vue";
import DataView from "@/views/DataView.vue";
import OliSync from "@/views/oli/OliSync.vue";
import StbTemplate from "@/views/oli/StbTemplate.vue";
import Company from "@/views/Company.vue";
import Setting from "@/views/Setting.vue";
import Agent from "@/views/account/Agent.vue";
import ChemicalDevice from "@/views/chemical/device/index.vue";
import ChemicalApproval from "@/views/chemical/approval/index.vue";


Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                requiresAuth: false, // 不需要登录
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {requiresAuth: true, title: '仪表盘', icon: 'el-icon-cloudy'}
        },
        {
            path: '/office',
            name: 'office',
            component: OfficeList,
            meta: {requiresAuth: true, title: '企业管理', icon: 'el-icon-machine'},

        },
        {
            path: '/',
            name: 'dashboard',
            component: Dashboard,
            meta: {requiresAuth: true, title: '仪表盘'},

        },
        {
            path: '/devicestemplate',
            name: 'devicestemplate',
            component: DevicesTemplate,
            meta: {requiresAuth: true, title: '设备模板', icon: 'el-icon-c-scale-to-original'},

        },
        {
            path: '/devices',
            name: 'devices',
            component: DeviceList,
            meta: {requiresAuth: true, title: '设备列表', icon: 'el-icon-machine'},

        },
        {
            path: '/sensor',
            name: 'SensorList',
            component: SensorList,
            meta: {requiresAuth: true, title: '传感器管理', icon: 'el-icon-machine'}
        },
        {
            path: '/alerts',
            name: 'alerts',
            component: Alerts,
            meta: {requiresAuth: true, title: '告警信息', icon: 'el-icon-warning'}
        },
        // {
        //   path: '/alertRule',
        //   name: 'alertRule',
        //   component: AlertRule,
        //   meta: { requiresAuth: true, title: '告警规则', icon: 'l-icon-odometer' }
        // },
        {
            path: '/systemClassification',
            name: 'systemClassification',
            component: SystemClassification,
            meta: {requiresAuth: true, title: '系统分类', icon: 'el-icon-coin'}
        },
        {
            path: '/subscribe',
            name: 'subscribe',
            component: Subscribe,
            meta: {requiresAuth: true, title: 'mqtt订阅', icon: 'el-icon-cloudy'}
        },
        {
            path: '/certify',
            name: 'certify',
            component: Certify,
            meta: {requiresAuth: true, title: '证书管理', icon: 'el-icon-cloudy'}
        },
        {
            path: '/templateCertify',
            name: 'templateCertify',
            component: TemplateCertify,
            meta: {requiresAuth: true, title: '配套证书',}
        },
        {
            path: '/specifiedCertify',
            name: 'specifiedCertify',
            component: SpecifiedCertify,
            meta: {requiresAuth: true, title: '专用证书'}
        },

        {
            path: '/userAccount',
            name: 'userAccount',
            component: UserAccount,
            meta: {requiresAuth: true, title: '用户管理', icon: 'el-icon-warning'}
        },
        {
            path: '/role',
            name: 'role',
            component: Role,
            meta: {requiresAuth: true, title: '角色管理', icon: 'el-icon-warning'}
        },
        {
            path: '/resource',
            name: 'resource',
            component: Resource,
            meta: {requiresAuth: true, title: '资源管理', icon: 'el-icon-warning'}
        },

        {
            path: '/category',
            name: 'category',
            component: Category,
            meta: {requiresAuth: true, title: '设备分类', icon: 'el-icon-warning'}
        },

        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            meta: {requiresAuth: true, title: '系统设置', icon: 'el-icon-setting'}
        },
        {
            path: '/setting',
            name: 'setting',
            component: Setting,
            meta: {requiresAuth: true, title: '系统设置', icon: 'el-icon-setting'}
        },
        {
            path: '/dataview',
            name: 'dataview',
            component: DataView,
            meta: {requiresAuth: true, title: '数据大屏', icon: 'el-icon-data-analysis'}
        },
        {
            path: '/oliSync',
            name: 'oliSync',
            component: OliSync,
            meta: {requiresAuth: true, title: '油仓上传'}
        },
        {
            path: '/stbTemplate',
            name: 'stbTemplate',
            component: StbTemplate,
            meta: {requiresAuth: true, title: '市平台类目'}
        },
        {
            path: '/company',
            name: 'company',
            component: Company,
            meta: {requiresAuth: true, title: '企业信息'}
        },
        {
            path: '/agent',
            name: 'agent',
            component: Agent,
            meta: {requiresAuth: true, title: '平台代理商'}
        },
        {
            path: '/chemicalDevice',
            name: 'chemicalDevice',
            component: ChemicalDevice,
            meta: {requiresAuth: true, title: '危化贮存设施'}
        },
        {
            path: '/chemicalApproval',
            name: 'chemicalApproval',
            component: ChemicalApproval,
            meta: {requiresAuth: true, title: '贮存设备审核'}
        },
        {
            path: '/chemicalApproval/detail/:id',
            name: 'chemicalApprovalDetail',
            component: () => import('@/views/chemical/approval/Detail.vue'),
            props: true,
            meta: {requiresAuth: true, title: '审批详情'}
        },
        {
            path: '/chemInfo',
            name: 'chemInfo',
            component: () => import('@/views/chemical/chemInfo/index.vue'),
            meta: {requiresAuth: true, title: '危化品信息'}
        },
        {
            path: '/chemInfo/detail/:id',
            name: 'chemInfoDetail',
            component: () => import('@/views/chemical/chemInfo/detail.vue'),
            props: true,
            meta: {requiresAuth: true, title: '危化品详情'}
        },



        {
            path: '/quote',
            name: 'quote',
            component: () => import('@/views/quote/index.vue'),
            meta: {requiresAuth: true, title: '报价管理', icon: 'el-icon-edit-outline'}
        },
        {
            path: '/productModel',
            name: 'productModel',
            component: () => import('@/views/quote/productModel.vue'),
            meta: {requiresAuth: true, title: '产品型号'}
        },
        {
            path: '/productSize',
            name: 'productSize',
            component: () => import('@/views/quote/productSize.vue'),
            meta: {requiresAuth: true, title: '产品尺寸'}
        },
        {
            path: '/configGroup',
            name: 'configGroup',
            component: () => import('@/views/quote/configGroup.vue'),
            meta: {requiresAuth: true, title: '产品配置'}
        },
        {
            path: '/productBaseMarginRate',
            name: 'productBaseMarginRate',
            component: () => import('@/views/quote/productBaseMarginRate.vue'),
            meta: {requiresAuth: true, title: '产品基准毛利'}
        },
        {
            path: '/productModelOperationFee',
            name: 'productModelOperationFee',
            component: () => import('@/views/quote/productModelOperationFee.vue'),
            meta: {requiresAuth: true, title: '产品运维费配置'} 
        },
        {
            path: '/productParamRel',
            name: 'productParamRel',
            component: () => import('@/views/quote/productParamRel.vue'),
            meta: {requiresAuth: true, title: '产品参数关联数据'} 
        },
        {
            path: '/productParamGroup',
            name: 'productParamGroup',
            component: () => import('@/views/quote/productParamGroup.vue'),
            meta: {requiresAuth: true, title: '产品参数分组数据'} 
        },
        {
            path: '/templateProductModel',
            name: 'templateProductModel',
            component: () => import('@/views/quote/modelProduct/templateProductModel.vue'),
            meta: {requiresAuth: true, title: '模板产品型号'}
        },
        {
            path: '/templateProductModel/detail/:id',
            name: 'templateProductModelDetail',
            component: () => import('@/views/quote/modelProduct/templateProductModelDetail.vue'),
            props: true,
            meta: {requiresAuth: true, title: '模板产品型号详情'}
        },
        {
            path: '/templateProductSize',
            name: 'templateProductSize',
            component: () => import('@/views/quote/modelSizeProduct/templateProductSize.vue'),
            meta: {requiresAuth: true, title: '模板产品尺寸'}
        },
        {
            path: '/templateProductSize/detail/:id',
            name: 'templateProductSizeDetail',
            component: () => import('@/views/quote/modelSizeProduct/templateProductSizeDetail.vue'),
            props: true,
            meta: {requiresAuth: true, title: '模板产品尺寸详情'}
        }

    ]
})
// 路由拦截 - 全局前置守卫
router.beforeEach((to, from, next) => {
    // 设置页面标题
    document.title = to.meta.title ? `${to.meta.title} - 物联网管理后台` : '物联网管理后台'

    // 检查是否需要登录
    if (to.meta.requiresAuth) {
        // 获取本地存储的token
        const token = localStorage.getItem('token')

        // 没有token，需要登录
        if (!token) {
            next({path: '/login', query: {redirect: to.fullPath}})
            return
        }

        // 检查用户权限
        if (to.meta.roles && to.meta.roles.length > 0) {
            // 从store获取当前用户角色
            const userRole = Vue.prototype.$store.state.user.userInfo.role

            // 检查用户是否有访问权限
            if (!to.meta.roles.includes(userRole)) {
                // 没有权限，重定向到404或首页
                next({path: '/404'})
                return
            }
        }

        // 有token且有权限，允许访问
        next()
    } else {
        // 不需要登录的页面
        // 如果已登录访问登录页，重定向到首页
        const token = localStorage.getItem('token')
        if (to.path === '/login' && token) {
            next({path: '/'})
            return
        }

        next()
    }
})

// 路由拦截 - 全局后置钩子
router.afterEach((to, from) => {
    // 可以在这里添加页面加载完成后的操作，如埋点统计等
})

export default router